module.exports = __webpack_public_path__ + "img/grayTick.0996e33b.png";